<template>
    <div v-if="canBeValidated">
        <b-link title="Tiers non validé" @click="showConfirmationModal()">
            <i class="fas fa-fw fa-exclamation-triangle text-warning"></i>
        </b-link>
    </div>
    <div v-else>
        <span title="Tiers non validé">
            <i class="fas fa-fw fa-exclamation-triangle text-warning"></i>
        </span>
    </div>
</template>

<script>
export default {
    name: 'ValidateClientHandler',

    props: {
        id: 0,
        iValid: false,
        canBeValidated: false,
    },

    methods: {
        showConfirmationModal() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes vous sûr·e de vouloir valider ce tiers ?',
                    {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: 'Valider',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: false,
                    }
                )
                .then((value) => {
                    //
                    if (value) {
                        this.validateItem()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async validateItem() {
            try {
                await axios.put(`/clients/${this.id}/validate`)
                this.$root.$refs.clientsTable.getItems()
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
